import { Component, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { Location } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CrowdinOtaService } from '../../services/crowdin-ota/crowdin-ota.service';
import { LanguageService } from '../../services/language.service';
import { TranslationService } from '../../services/translation.service';


@Component({
    selector: 'app-language-selection-page',
    templateUrl: './language-selection-page.component.html',
    styleUrls: ['./language-selection-page.component.scss'],
    imports: [TranslateModule],
    standalone: true
})
export class LanguageSelectionPageComponent implements OnInit {

  @Output() public islanguagePageVisible = new EventEmitter<any>();
  @Output() public sendLangId = new EventEmitter<any>();
  allLanguages: any[] = [];
  translationData = [];
  raceId: any = '';
  constructor(private readonly translationService: TranslationService,
    private readonly _languageService: LanguageService,
    private readonly _crowdinOtaService: CrowdinOtaService,
    private readonly _router: Router,
    private readonly location: Location,
    private readonly renderer: Renderer2,
  ) { }

  ngOnInit(): void {

    this.allLanguages = this.translationService.supportedLanguagesForDisplay;
  }

  public closeLanguagePicker() {
    this._languageService.setIsLanguageSelectionOpen(false);
    this.renderer.removeStyle(document.body, 'overflow');
    this._languageService.showLanguageSelectionPage(false);
  }

  public emitLangId(id: any) {
    this.sendLangId.emit(id);
    this.islanguagePageVisible.emit(false);
  }

  public async switchLanguage(language: string): Promise<void> {
    const pattern = /\/[a-z]{2}-[A-Z]{2}(?=\/|$)/;
    const currentUrl = this._router.url;
    let updatedUrl = '';
    if (pattern.test(currentUrl)) {
      updatedUrl = currentUrl.replace(pattern, `/${language}`);
    } else {
      // If no language pattern found, prepend the language to the URL
      updatedUrl = `/${language}${currentUrl}`;
    }

    this.location.replaceState(updatedUrl);
    const languageCode = language.split('-')[0];

    try {
      await this._crowdinOtaService.useLanguage(languageCode);
      localStorage.setItem('language', language);
      localStorage.setItem('languagePicked', 'true');
    } catch (error) {
      console.error('Error switching language:', error);
    } finally {
      setTimeout(() => {
        this.closeLanguagePicker();
      }, 10);
    }

  }


  public addRaceIdWithLanguage() {
    const raceLang = {
      'languagePicked': true,
      'raceid': this.raceId
    }
    localStorage.setItem('languagePicked', JSON.stringify(raceLang))
  }
}
